import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Add your society",
    body:
      "Search your apartment, link your car and parking. We handle the RWA approvals.",
  },
  {
    n: "02",
    title: "Pick a plan",
    body:
      "Everyday or Alternate-Day. Basic or Premium. Pause, upgrade, downgrade — no contracts.",
  },
  {
    n: "03",
    title: "Zypper arrives",
    body:
      "Geo-fenced check-in, photo checkpoints before & after. You stay asleep.",
  },
  {
    n: "04",
    title: "Sparkling clean. Done.",
    body:
      "Get a photo receipt and a fresh ride — straight from your parking spot.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-steps"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-zyp-navy/10 bg-zyp-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="text-xs uppercase tracking-[0.22em] text-zyp-navy/60 mb-4">
            How it works
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight max-w-3xl mx-auto text-zyp-navy">
            Four taps from chaos to a calendar-cleaned car.
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-zyp-navy/15 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`how-step-${i}`}
                className="relative"
              >
                <div className="relative h-24 w-24 mx-auto lg:mx-0 mb-6 rounded-full border border-zyp-navy/10 bg-zyp-cream flex items-center justify-center">
                  <span className="font-heading text-2xl font-medium text-zyp-highlight">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-heading text-2xl font-medium tracking-tight text-center lg:text-left text-zyp-navy">
                  {s.title}
                </h3>
                <p className="mt-2 text-zyp-navy/70 text-sm leading-relaxed text-center lg:text-left max-w-[260px] lg:mx-0 mx-auto">
                  {s.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
